{
  "version": 1,
  "asset_id": "13285511-729c-4f10-a0c8-1d741ccd1756",
  "project_id": "a3e359cb-5308-4f2a-8ac0-def799d4abdd",
  "url": "/__l5e/assets-v1/13285511-729c-4f10-a0c8-1d741ccd1756/thumb-appropriation.webp",
  "r2_key": "a/v1/a3e359cb-5308-4f2a-8ac0-def799d4abdd/13285511-729c-4f10-a0c8-1d741ccd1756/thumb-appropriation.webp",
  "original_filename": "thumb-appropriation.webp",
  "size": 161822,
  "content_type": "image/webp",
  "created_at": "2026-08-30T13:03:48Z"
}
